import { ReactElement } from "react";
import { volumeHighOutline } from "ionicons/icons";
import { QuestionType } from "../../../../types/Question";
import Card, { cardSurface } from "../../../atoms/Card";
import styled from "styled-components";
import Icon from "../../../atoms/Icon";
import { useConfig } from "../../../../contexts/ConfigContext";

interface QuestionDisplayProps {
  answerComp: ReactElement;
  question: QuestionType;
  ruleMessage?: string;
  onReadQuestionClick: () => void;
  cardMargin?: string;
}

const QuestionDisplay = ({
  answerComp,
  question,
  ruleMessage,
  onReadQuestionClick,
  cardMargin,
}: QuestionDisplayProps): ReactElement => {
  const { title, description, is_mandatory_question: mandatory } = question;

  const { selectedRole } = useConfig();
  const isVocalisationEnabled =
    selectedRole?.attributes?.is_vocalisation_enabled;

  return (
    <QuestionCard $margin={cardMargin}>
      {/* Question title + description */}
      <QuestionHeader>
        <TitleGroup>
          <Title>{mandatory ? `${title} *` : title}</Title>
          <SubTitle>{description}</SubTitle>
        </TitleGroup>
        {isVocalisationEnabled && (
          <HeaderIcon onClick={onReadQuestionClick} icon={volumeHighOutline} />
        )}
      </QuestionHeader>
      <Desc>{ruleMessage}</Desc>

      {answerComp}
    </QuestionCard>
  );
};

const QuestionCard = styled(Card)`
  padding: 22px;
  ${cardSurface}
  // overflow: auto;
  // max-height: 600px;

  // @media (max-height: 730px) {
  //   max-height: 400px;
  // }
  // @media (max-height: 630px) {
  //   max-height: 350px;
  // }
  // @media (max-height: 580px) {
  //   max-height: 300px;
  // }
  // @media (max-height: 530px) {
  //   max-height: 250px;
  // }
  // @media (max-height: 480px) {
  //   max-height: 200px;
  // }
`;

const QuestionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const TitleGroup = styled.div`
  /* Allow the title block to shrink/wrap so it doesn't squeeze the icon. */
  min-width: 0;
`;

const HeaderIcon = styled(Icon)`
  color: ${(props) => props.theme.primary.main};
  padding: 0px;
  font-size: 20px;
  /* Keep the speaker icon at full size even when the title is long. */
  flex-shrink: 0;
`;

const Title = styled.div`
  color: ${(props) => props.theme.primary.main};
  font-size: 18px;
  font-weight: 600;
  /* Question titles follow the theme's title font (a div, so the global
     h1-h6 heading rule in App.scss doesn't reach it). */
  font-family: var(--app-font-heading, var(--app-font-family, inherit));
`;

const SubTitle = styled.div`
  font-size: 14px;
  color: #6b6b6b;
  margin-top: 2px;
`;

const Desc = styled.div`
  color: grey;
  font-size: 14px;
  margin-top: 6px;
  border-bottom: 1px solid #ececec;
  padding-bottom: 8px;
`;


export default QuestionDisplay;
